import { useNavigate } from "react-router-dom";
import Card from "components/v2/Card/Card";
import { ReactComponent as CheckIcon } from "assets/images/iconsV2/check-green.svg";
import ProviderLogo from "components/atoms/ProviderLogo/ProviderLogo";
import IconCircle from "components/v2/IconCircle/IconCircle";
import Amount from "components/v2/Amount/Amount";

export type QuoteApprovalCardProps = {
  showIcon?: boolean;
  title?: string;
  subtitle?: string;
  description?: string;
  providerLogo?: string;
  providerName?: string;
  freightMode?: string;
  currency?: string;
  amount?: string;
  shipmentId: string;
};

function QuoteApprovalCard(props: QuoteApprovalCardProps): JSX.Element {
  const { showIcon, title, subtitle, description, providerLogo, providerName, freightMode, currency, amount, shipmentId } =
    props;
  const navigate = useNavigate();

  const handleViewQuoteRequest = () => {
    navigate(`/shipment/${shipmentId}`);
  };
  return (
    <Card borderRadius="sm" shadow="sm" style={{ maxWidth: "640px" }}>
      <Card.Body>
        <div className="quote-approval__card-container">
          {showIcon && (
            <div className="mb-3xl">
              <IconCircle icon={CheckIcon} size="lg" color="success" />
            </div>
          )}
          {title && <div className="text-primary display-xs font-semibold mb-xs">{title}</div>}
          {subtitle && <div className="text-tertiary text-sm font-medium mb-lg">{subtitle}</div>}
          {description && <div className="text-primary text-md font-regular text-center">{description}</div>}
          <div className="my-3xl quote-approval__quote-info-container">
            <div className="d-flex justify-content-center align-items-center pr-3xl">
              {(providerLogo || providerName) && (
                <div className="mr-lg">
                  <ProviderLogo
                    logo={providerLogo}
                    name={providerName}
                    containerStyles={{ width: 40, height: 40, borderRadius: 20 }}
                    imageStyles={{ width: 40, height: 40, borderRadius: 20 }}
                  />
                </div>
              )}
              <div className="d-flex flex-column">
                {providerName && <div className="text-primary text-md font-medium">{providerName}</div>}
                {freightMode && <div className="quote-approval__freight-mode text-sm font-regular">{freightMode}</div>}
              </div>
            </div>
            {!!amount && !!currency && (
              <div>
                <Amount amount={amount} currency={currency} context="body" size="xl" />
              </div>
            )}
          </div>
          <div className="text-primary text-md font-regular">
            You may close this page or{" "}
            <span className="text-brand-tertiary-400 quote-approval__link" onClick={handleViewQuoteRequest}>
              view the quote request
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default QuoteApprovalCard;

QuoteApprovalCard.defaultProps = {
  showIcon: false,
  title: undefined,
  subtitle: undefined,
  description: undefined,
  providerLogo: undefined,
  providerName: undefined,
  freightMode: undefined,
  amount: undefined,
  currency: undefined,
};
